import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconFaceIdFace: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconFaceIdFace"><Path fillRule="evenodd" clipRule="evenodd" d="M6 4V9H4V4H6ZM20 4V9H18V4H20ZM14 5V12.5C14 14.1569 12.6569 15.5 11 15.5H10V13.5H11C11.5523 13.5 12 13.0523 12 12.5V5H14ZM5.8666 16.0921L6.63725 16.7293C8.53151 18.2957 10.3059 19 12 19C13.6941 19 15.4685 18.2957 17.3627 16.7293L18.1334 16.0921L19.4079 17.6334L18.6373 18.2707C16.5004 20.0376 14.2903 21 12 21C9.70965 21 7.49962 20.0376 5.36275 18.2707L4.59209 17.6334L5.8666 16.0921Z" fill="currentColor"/></CentralIconBase>;
});

export default IconFaceIdFace;
